document.addEventListener("DOMContentLoaded", () => {
    const sliderSections = document.querySelectorAll('.section-collections__slider');
    const fixedHeader = document?.querySelector('.fixed--collections');

    if (sliderSections.length > 0) {

        sliderSections.forEach(sliderSection => {
            const sliderSpaceBetween = +sliderSection.dataset.spaceBetween;
            const sliderSpaceBetweenMobile = +sliderSection.dataset.spaceBetweenMobile;
            sliderSection.querySelectorAll(".section-collections__slide").forEach(slide => {
                const link = slide.querySelector("a")?.getAttribute("href")
                if(!link) return
                slide.addEventListener("click", (event)=>{
                    if(!link.includes("#")) window.location.href = link

                    const sectionLink = document.querySelector(`${link}`)
                    if(!sectionLink) return
                    const topPosition = sectionLink.getBoundingClientRect().top + window.pageYOffset - 150;
                    window.scrollTo({ top: topPosition, behavior: "smooth" });

                })

            })


            new Swiper(sliderSection, {
                spaceBetween: 80,
                slidesPerView: 5,
                breakpoints: {
                    0: {
                        spaceBetween: sliderSpaceBetweenMobile,
                        slidesPerView: 4.4
                    },
                    576: {
                        spaceBetween: 20,
                        slidesPerView: 5,
                    },
                    991: {
                        spaceBetween: sliderSpaceBetween,
                        slidesPerView: 5,
                    }
                }
            });
        });
    }
});
